import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  useListCrewLocationsQuery,
  useListBackstageLocationsQuery,
  useListBarLocationsQuery,
} from '../../redux/api/locationApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const ListCrewLocations = () => {
  const currentEvent = useSelector((state) => state.auth.currentEvent);
  const { data: crewLocations = [] } = useListCrewLocationsQuery(currentEvent?.id, {
    skip: !currentEvent?.id,
  });
  const { data: backstageLocations = [] } = useListBackstageLocationsQuery(currentEvent?.id, {
    skip: !currentEvent?.id,
  });
  // Bars only exist as delivery targets when the event has bar deliveries on.
  const { data: barLocations = [] } = useListBarLocationsQuery(currentEvent?.id, {
    skip: !currentEvent?.id || !currentEvent?.bar_deliveries,
  });
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');

  const allLocations = [
    ...crewLocations.map((loc) => ({ ...loc, type: 'crew' })),
    ...backstageLocations.map((loc) => ({ ...loc, type: 'backstage' })),
    ...barLocations.map((loc) => ({ ...loc, type: 'bar' })),
  ].sort((a, b) => a.name.localeCompare(b.name));

  const filteredLocations = allLocations
    .filter((loc) => typeFilter === 'all' || loc.type === typeFilter)
    .filter((loc) =>
      loc.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const TYPE_BADGES = {
    backstage: { label: 'Backstage', cls: 'bg-primary' },
    bar: { label: 'Bar', cls: 'bg-dark' },
    crew: { label: 'Crew', cls: 'bg-secondary' },
  };

  const handleDetails = (loc) => {
    if (loc.type === 'backstage') {
      navigate(`/backstage-location/${loc.id}/`);
    } else if (loc.type === 'bar') {
      navigate(`/bar-location/${loc.id}/`);
    } else {
      navigate(`/crew-location/${loc.id}/`);
    }
  };

  return (
    <Fragment>
      <h4>Lieferziele</h4>

      <div className='row g-2 mb-3'>
        <div className='col-12 col-md-8'>
          <input
            type='text'
            className='form-control'
            placeholder='Lieferziel suchen...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className='col-12 col-md-4'>
          <select
            className='form-select'
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
          >
            <option value='all'>Alle Typen</option>
            <option value='crew'>Crew</option>
            <option value='backstage'>Backstage</option>
            {barLocations.length > 0 && <option value='bar'>Bar</option>}
          </select>
        </div>
      </div>

      {allLocations.length === 0 ? (
        <p>Keine Lieferziele gefunden.</p>
      ) : (
        <>
          <table className='table table-striped mt-4 align-middle text-start'>
            <thead>
              <tr>
                <th>Lieferziel</th>
                <th>Typ</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {filteredLocations.map((loc) => (
                <tr key={loc.id}>
                  <td>{loc.name}</td>
                  <td>
                    <span
                      className={`badge ${
                        (TYPE_BADGES[loc.type] || TYPE_BADGES.crew).cls
                      }`}
                    >
                      {(TYPE_BADGES[loc.type] || TYPE_BADGES.crew).label}
                    </span>
                  </td>
                  <td>
                    <button
                      className='ms-3 btn btn-info btn-sm'
                      onClick={() => handleDetails(loc)}
                    >
                      <FontAwesomeIcon icon={faClipboardCheck} className='me-2' />
                      Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredLocations.length === 0 && searchTerm && (
            <p className='text-muted'>
              Keine Lieferziele gefunden für "{searchTerm}".
            </p>
          )}
        </>
      )}
    </Fragment>
  );
};

export default ListCrewLocations;
